/* eslint-disable sonarjs/no-duplicate-string */
export const PLAN_BOATS = [
  {
    id: '12-metre',
    name: '12 Metre',
    tier: 'Grand Prix',
    category: 'maxi',
    tags: [],
    prices: { day: 60, month: 343.2, year: 1359.2 },
  },
  {
    id: '125-kvm-krysser',
    name: '12,5 kvm Krysser',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: '16ft-skiff',
    name: '16ft Skiff',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: '18ft-skiff',
    name: '18ft Skiff',
    tier: 'One Design',
    category: 'one-design',
    tags: ['Group1'],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: '1d35',
    name: '1D35',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Group1'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: '24-metre',
    name: '2.4 Metre',
    tier: 'One Design',
    category: 'dinghy',
    tags: ['Group1'],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: '29er',
    name: '29er',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: '420',
    name: '420',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: '43-ft-irc',
    name: '43 ft IRC',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: '470',
    name: '470',
    tier: 'One Design',
    category: 'dinghy',
    tags: ['Olympic'],
    prices: { day: 10.39, month: 72, year: 719.2 },
  },
  {
    id: '49er',
    name: '49er',
    tier: 'One Design',
    category: 'dinghy',
    tags: ['Olympic'],
    prices: { day: 10.39, month: 72, year: 719.2 },
  },
  {
    id: '49erfx',
    name: '49erFX',
    tier: 'One Design',
    category: 'dinghy',
    tags: ['Olympic'],
    prices: { day: 10.39, month: 72, year: 719.2 },
  },
  {
    id: '55-metre',
    name: '5.5 Metre',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: '505',
    name: '505',
    tier: 'One Design',
    category: 'dinghy',
    tags: ['Group1'],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: '6-metre',
    name: '6 Metre',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: '69f',
    name: '69F',
    tier: 'Performance',
    category: 'foiling',
    tags: ['Foiling'],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'a-scow',
    name: 'A Scow',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Group1'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'a-class-catamaran',
    name: 'A-Class Catamaran',
    tier: 'One Design',
    category: 'dinghy',
    tags: ['Multihull'],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'ac40',
    name: 'AC40',
    tier: 'Grand Prix',
    category: 'foiling',
    tags: ['Foiling', 'Group3'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'ac75',
    name: 'AC75',
    tier: 'Grand Prix',
    category: 'foiling',
    tags: ['Foiling', 'Group3'],
    prices: { day: 119.2, month: 959.2, year: 3839.2 },
  },
  {
    id: 'adams-10',
    name: 'Adams 10',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Group1'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'albacore',
    name: 'Albacore',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'albin-express',
    name: 'Albin Express',
    tier: 'One Design',
    category: 'one-design',
    tags: ['Group1'],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'alerion-28',
    name: 'Alerion 28',
    tier: 'One Design',
    category: 'one-design',
    tags: ['Group1'],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'andrews-68',
    name: 'Andrews 68',
    tier: 'Grand Prix',
    category: 'maxi',
    tags: [],
    prices: { day: 119.2, month: 959.2, year: 3839.2 },
  },
  {
    id: 'archambault-a35',
    name: 'Archambault A35',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Group1'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'archambault-a40',
    name: 'Archambault A40',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'arrow-catamaran',
    name: 'Arrow (Catamaran)',
    tier: 'One Design',
    category: 'dinghy',
    tags: ['Multihull'],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'asso99',
    name: 'Asso99',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'bakewell-white-8',
    name: 'Bakewell-White 8',
    tier: 'One Design',
    category: 'one-design',
    tags: ['Group1'],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'beneteau-367',
    name: 'Beneteau 36.7',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'beneteau-first-305',
    name: 'Beneteau First 305',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'beneteau-first-347-10r',
    name: 'Beneteau First 34.7 (10R)',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Group1'],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'beneteau-first-40',
    name: 'Beneteau First 40',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Group1'],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'beneteau-first-407',
    name: 'Beneteau First 40.7',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Group1'],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'beneteau-first-42s7',
    name: 'Beneteau First 42s7',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'beneteau-first-53',
    name: 'Beneteau First 53',
    tier: 'Grand Prix',
    category: 'maxi',
    tags: [],
    prices: { day: 10.39, month: 72, year: 719.2 },
  },
  {
    id: 'beneteau-first-class-8',
    name: 'Beneteau First Class 8',
    tier: 'One Design',
    category: 'one-design',
    tags: ['Group1'],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'beneteau-oceanis-38',
    name: 'Beneteau Oceanis 38',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'beneteau-oceanis-411',
    name: 'Beneteau Oceanis 411',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'beneteauplatu-25',
    name: 'Beneteau/Platu 25',
    tier: 'One Design',
    category: 'one-design',
    tags: ['Group1'],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'birdyfish',
    name: 'Birdyfish',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'botin-40',
    name: 'Botin 40',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 60, month: 343.2, year: 1359.2 },
  },
  {
    id: 'botin-44',
    name: 'Botin 44',
    tier: 'Grand Prix',
    category: 'keelboat',
    tags: ['Group3'],
    prices: { day: 60, month: 343.2, year: 1359.2 },
  },
  {
    id: 'bries-27',
    name: 'BRIES 27',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'c-scow',
    name: 'C Scow',
    tier: 'One Design',
    category: 'one-design',
    tags: ['Group1'],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'cc-30',
    name: 'C&C 30',
    tier: 'One Design',
    category: 'one-design',
    tags: ['Group1'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'cal-40',
    name: 'Cal 40',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Group1'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'cape31',
    name: 'Cape31',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Group1'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'capri-22',
    name: 'Capri 22',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'carkeek-47',
    name: 'Carkeek 47',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 119.2, month: 959.2, year: 3839.2 },
  },
  {
    id: 'catalina-22',
    name: 'Catalina 22',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'cfj',
    name: 'CFJ',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'cherub',
    name: 'Cherub',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'class-40',
    name: 'Class 40',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Group1'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'clubswan-28',
    name: 'ClubSwan 28',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'clubswan-36',
    name: 'ClubSwan 36',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Group1'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'clubswan-42',
    name: 'ClubSwan 42',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Group1'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'clubswan-50',
    name: 'ClubSwan 50',
    tier: 'Grand Prix',
    category: 'maxi',
    tags: ['Group1'],
    prices: { day: 60, month: 343.2, year: 1359.2 },
  },
  {
    id: 'clubswan-80',
    name: 'ClubSwan 80',
    tier: 'Grand Prix',
    category: 'maxi',
    tags: [],
    prices: { day: 119.2, month: 959.2, year: 3839.2 },
  },
  {
    id: 'coastal-rowing-1x',
    name: 'Coastal Rowing 1x',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'contender',
    name: 'Contender',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'cookson-50',
    name: 'Cookson 50',
    tier: 'Grand Prix',
    category: 'maxi',
    tags: [],
    prices: { day: 60, month: 343.2, year: 1359.2 },
  },
  {
    id: 'd35',
    name: 'D35',
    tier: 'Performance',
    category: 'foiling',
    tags: ['Foiling', 'Multihull'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'dart-18',
    name: 'Dart 18',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'dehler-29',
    name: 'Dehler 29',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'dehler-30-od',
    name: 'Dehler 30 OD',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Keelboat'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'delphia-24',
    name: 'Delphia 24',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'dk46',
    name: 'DK46',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'dn-ice-boat',
    name: 'DN Ice Boat',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'dolphin-81',
    name: 'Dolphin 81',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'dragon',
    name: 'Dragon',
    tier: 'One Design',
    category: 'one-design',
    tags: ['Group1'],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'dufour-350-gl',
    name: 'Dufour 350 GL',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'dufour-40',
    name: 'Dufour 40',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'e-scow',
    name: 'E Scow',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'efsix',
    name: 'Efsix',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'elan-310',
    name: 'Elan 310',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'elliott-59',
    name: 'Elliott 5.9',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'esse-750',
    name: 'Esse 750',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'esse-850',
    name: 'Esse 850',
    tier: 'One Design',
    category: 'one-design',
    tags: ['Group1'],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'etchells',
    name: 'Etchells',
    tier: 'One Design',
    category: 'one-design',
    tags: ['Group1'],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'etf26',
    name: 'ETF26',
    tier: 'Performance',
    category: 'foiling',
    tags: ['Foiling'],
    prices: { day: 10.39, month: 72, year: 719.2 },
  },
  {
    id: 'europe',
    name: 'Europe',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'evelyn-32',
    name: 'Evelyn 32',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'express-37',
    name: 'Express 37',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'f101',
    name: 'F101',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'f50',
    name: 'F50',
    tier: 'Performance',
    category: 'foiling',
    tags: ['Foiling', 'Multihull'],
    prices: { day: 79.2, month: 207.2, year: 2079.2 },
  },
  {
    id: 'fareast-19',
    name: 'Fareast 19',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'fareast-28r',
    name: 'Fareast 28R',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'farr-30',
    name: 'Farr 30',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 10.39, month: 72, year: 719.2 },
  },
  {
    id: 'farr-395',
    name: 'Farr 395',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Group1'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'farr-40',
    name: 'Farr 40',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Group1'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'farr-gp42',
    name: 'Farr GP42',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 60, month: 343.2, year: 1359.2 },
  },
  {
    id: 'farrier-f-85sr',
    name: 'Farrier F-85SR',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'fast40',
    name: 'Fast40',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Group1'],
    prices: { day: 60, month: 343.2, year: 1359.2 },
  },
  {
    id: 'ff65',
    name: 'FF65',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'figaro-3',
    name: 'Figaro 3',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'finn',
    name: 'Finn',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'finngulf-31',
    name: 'Finngulf 31',
    tier: 'One Design',
    category: 'one-design',
    tags: ['Group1'],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'fireball',
    name: 'Fireball',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'firstseascape-18',
    name: 'First/Seascape 18',
    tier: 'One Design',
    category: 'dinghy',
    tags: ['Group1'],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'firstseascape-24',
    name: 'First/Seascape 24',
    tier: 'One Design',
    category: 'one-design',
    tags: ['Group1'],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'firstseascape-27',
    name: 'First/Seascape 27',
    tier: 'One Design',
    category: 'one-design',
    tags: ['Group1'],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'flying-15',
    name: 'Flying 15',
    tier: 'One Design',
    category: 'one-design',
    tags: ['Group1'],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'flying-dutchman',
    name: 'Flying Dutchman',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'flying-scot',
    name: 'Flying Scot',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'foiling-windsurf',
    name: 'Foiling Windsurf',
    tier: 'Performance',
    category: 'foiling',
    tags: ['Board', 'Foiling'],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'formula-18',
    name: 'Formula 18',
    tier: 'One Design',
    category: 'one-design',
    tags: ['Group1', 'Multihull'],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'formula-kite',
    name: 'Formula Kite',
    tier: 'One Design',
    category: 'dinghy',
    tags: ['Board', 'Olympic'],
    prices: { day: 10.39, month: 72, year: 719.2 },
  },
  {
    id: 'frers-33',
    name: 'Frers 33',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Group1'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'frers-60-ft',
    name: 'Frers 60 ft',
    tier: 'Grand Prix',
    category: 'maxi',
    tags: [],
    prices: { day: 119.2, month: 959.2, year: 3839.2 },
  },
  {
    id: 'gc32',
    name: 'GC32',
    tier: 'Performance',
    category: 'foiling',
    tags: ['Foiling', 'Multihull'],
    prices: { day: 60, month: 343.2, year: 1359.2 },
  },
  {
    id: 'gs-44',
    name: 'GS 44',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Group1'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'h-boat',
    name: 'H-boat',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'h-jolle',
    name: 'H-Jolle',
    tier: 'One Design',
    category: 'one-design',
    tags: ['Group1'],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'h22',
    name: 'H22',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'hadron-h2',
    name: 'Hadron H2',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'hai',
    name: 'Hai',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'half-ton',
    name: 'Half Ton',
    tier: 'One Design',
    category: 'one-design',
    tags: ['Group1'],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'harbor-20',
    name: 'Harbor 20',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'hh42',
    name: 'HH42',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Group1'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'hobie-14',
    name: 'Hobie 14',
    tier: 'One Design',
    category: 'dinghy',
    tags: ['Multihull'],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'hobie-16',
    name: 'Hobie 16',
    tier: 'One Design',
    category: 'dinghy',
    tags: ['Multihull'],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'hobie-magic-25',
    name: 'Hobie Magic 25',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'hobie-tiger',
    name: 'Hobie Tiger',
    tier: 'One Design',
    category: 'one-design',
    tags: ['Multihull'],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'hpe-25',
    name: 'HPE 25',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'hunter-horizon-27',
    name: 'Hunter Horizon 27',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'idra-14',
    name: 'IDRA 14',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'ifly15',
    name: 'iFLY15',
    tier: 'Performance',
    category: 'foiling',
    tags: ['Foiling', 'Multihull'],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'ilca-6-laser-radial',
    name: 'ILCA 6 (Laser Radial)',
    tier: 'One Design',
    category: 'dinghy',
    tags: ['Olympic'],
    prices: { day: 10.39, month: 72, year: 719.2 },
  },
  {
    id: 'ilca-7-laser',
    name: 'ILCA 7 (Laser)',
    tier: 'One Design',
    category: 'dinghy',
    tags: ['Olympic'],
    prices: { day: 10.39, month: 72, year: 719.2 },
  },
  {
    id: 'imoca-60',
    name: 'IMOCA 60',
    tier: 'Grand Prix',
    category: 'maxi',
    tags: ['Group3'],
    prices: { day: 119.2, month: 959.2, year: 3839.2 },
  },
  {
    id: 'impala-28',
    name: 'Impala 28',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'international-14',
    name: 'International 14',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'international-cadet',
    name: 'International Cadet',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'international-canoe',
    name: 'International Canoe',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'iom',
    name: 'IOM',
    tier: 'One Design',
    category: 'dinghy',
    tags: ['Group1'],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'iqfoil',
    name: 'iQFoil',
    tier: 'One Design',
    category: 'dinghy',
    tags: ['Board', 'Olympic'],
    prices: { day: 10.39, month: 72, year: 719.2 },
  },
  {
    id: 'irc-85',
    name: 'IRC 85',
    tier: 'Grand Prix',
    category: 'maxi',
    tags: [],
    prices: { day: 119.2, month: 959.2, year: 3839.2 },
  },
  {
    id: 'italia-yachts-1298',
    name: 'Italia Yachts 12.98',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'j-class',
    name: 'J Class',
    tier: 'Grand Prix',
    category: 'maxi',
    tags: ['Yacht'],
    prices: { day: 119.2, month: 959.2, year: 3839.2 },
  },
  {
    id: 'j100',
    name: 'J/100',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'j105',
    name: 'J/105',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Group1'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'j109',
    name: 'J/109',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Group1'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'j111',
    name: 'J/111',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Group1'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'j112e',
    name: 'J/112E',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Group1'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'j121',
    name: 'J/121',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Group1'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'j122',
    name: 'J/122',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Group1'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'j125',
    name: 'J/125',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'j133',
    name: 'J/133',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'j22',
    name: 'J/22',
    tier: 'One Design',
    category: 'one-design',
    tags: ['Group1'],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'j24',
    name: 'J/24',
    tier: 'One Design',
    category: 'one-design',
    tags: ['Group1'],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'j30',
    name: 'J/30',
    tier: 'One Design',
    category: 'one-design',
    tags: ['Group1'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'j70',
    name: 'J/70',
    tier: 'One Design',
    category: 'one-design',
    tags: ['Group1'],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'j80',
    name: 'J/80',
    tier: 'One Design',
    category: 'one-design',
    tags: ['Group1'],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'j88',
    name: 'J/88',
    tier: 'One Design',
    category: 'one-design',
    tags: ['Group1'],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'j92',
    name: 'J/92',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'j97',
    name: 'J/97',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'j99',
    name: 'J/99',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Group1'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'jpk-1010',
    name: 'JPK 1010',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'jpk-960',
    name: 'JPK 960',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'ker-46',
    name: 'KER 46',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Group1'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'king-40-irc',
    name: 'King 40 IRC',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 60, month: 343.2, year: 1359.2 },
  },
  {
    id: 'knarr',
    name: 'Knarr',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 10.39, month: 72, year: 719.2 },
  },
  {
    id: 'l30',
    name: 'L30',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'lacustre',
    name: 'Lacustre',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Group1'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'lago-26',
    name: 'Lago 26',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'landmark-43',
    name: 'Landmark 43',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 60, month: 343.2, year: 1359.2 },
  },
  {
    id: 'laser-28',
    name: 'Laser 28',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'lightning',
    name: 'Lightning',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'longtze-premier',
    name: 'Longtze Premier',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'mat-1220',
    name: 'M.A.T. 1220',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 60, month: 343.2, year: 1359.2 },
  },
  {
    id: 'mat-1245',
    name: 'M.A.T. 1245',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 60, month: 343.2, year: 1359.2 },
  },
  {
    id: 'm2',
    name: 'M2',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'marshall-15',
    name: 'Marshall 15',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'marstrm-32',
    name: 'Marstrom 32',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Multihull'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'martin-242',
    name: 'Martin 242',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'max-dolphin-62',
    name: 'Max-Dolphin 62',
    tier: 'Grand Prix',
    category: 'maxi',
    tags: [],
    prices: { day: 119.2, month: 959.2, year: 3839.2 },
  },
  {
    id: 'maxfun-25',
    name: 'Maxfun 25',
    tier: 'One Design',
    category: 'one-design',
    tags: ['Group1'],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'maxi-72',
    name: 'Maxi 72',
    tier: 'Grand Prix',
    category: 'maxi',
    tags: ['Group3'],
    prices: { day: 119.2, month: 959.2, year: 3839.2 },
  },
  {
    id: 'maxi-trimaran-ultime',
    name: 'Maxi Trimaran Ultime',
    tier: 'Grand Prix',
    category: 'maxi',
    tags: ['Group3'],
    prices: { day: 119.2, month: 959.2, year: 3839.2 },
  },
  {
    id: 'mc-scow',
    name: 'MC Scow',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'melges-14',
    name: 'Melges 14',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'melges-15',
    name: 'Melges 15',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'melges-20',
    name: 'Melges 20',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'melges-24',
    name: 'Melges 24',
    tier: 'One Design',
    category: 'one-design',
    tags: ['Group1'],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'melges-32',
    name: 'Melges 32',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Group1'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'melges-40',
    name: 'Melges 40',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Group1'],
    prices: { day: 60, month: 343.2, year: 1359.2 },
  },
  {
    id: 'melges-ic37',
    name: 'Melges IC37',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Group1'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'merlin-rocket',
    name: 'Merlin Rocket',
    tier: 'One Design',
    category: 'dinghy',
    tags: ['Group1'],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'meteor',
    name: 'Meteor',
    tier: 'One Design',
    category: 'one-design',
    tags: ['Group1'],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'mg14',
    name: 'MG14',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'micro',
    name: 'Micro',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'mills-45',
    name: 'Mills 45',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 60, month: 343.2, year: 1359.2 },
  },
  {
    id: 'mod-70',
    name: 'MOD 70',
    tier: 'Grand Prix',
    category: 'maxi',
    tags: ['Multihull'],
    prices: { day: 119.2, month: 959.2, year: 3839.2 },
  },
  {
    id: 'moore-24',
    name: 'Moore 24',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'moth',
    name: 'Moth',
    tier: 'Performance',
    category: 'foiling',
    tags: ['Foiling'],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'mount-gay-30',
    name: 'Mount Gay 30',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'nacra-15',
    name: 'Nacra 15',
    tier: 'One Design',
    category: 'dinghy',
    tags: ['Group1', 'Multihull'],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'nacra-17',
    name: 'Nacra 17',
    tier: 'Performance',
    category: 'foiling',
    tags: ['Foiling', 'Multihull', 'Olympic'],
    prices: { day: 10.39, month: 72, year: 719.2 },
  },
  {
    id: 'nacra-f16',
    name: 'Nacra F16',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'national-18',
    name: 'National 18',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'nautic-330',
    name: 'Nautic 330',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'nautic-370-run',
    name: 'Nautic 370 Run',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'nautica-450',
    name: 'Nautica 450',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'nordic-folkboat',
    name: 'Nordic Folkboat',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'ocean-50',
    name: 'Ocean 50',
    tier: 'Grand Prix',
    category: 'maxi',
    tags: ['Multihull'],
    prices: { day: 119.2, month: 959.2, year: 3839.2 },
  },
  {
    id: 'ok-dinghy',
    name: 'OK Dinghy',
    tier: 'One Design',
    category: 'dinghy',
    tags: ['Group1'],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'olson-30',
    name: 'Olson 30',
    tier: 'One Design',
    category: 'one-design',
    tags: ['Group1'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'omega-',
    name: 'Omega',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'omega-36',
    name: 'Omega 36',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'one-ton',
    name: 'One Ton',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Group1'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'onyx',
    name: 'Onyx',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'open-60',
    name: 'Open 60',
    tier: 'Grand Prix',
    category: 'maxi',
    tags: [],
    prices: { day: 119.2, month: 959.2, year: 3839.2 },
  },
  {
    id: 'open-skiff',
    name: 'Open Skiff',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'optimist',
    name: 'Optimist',
    tier: 'One Design',
    category: 'dinghy',
    tags: ['Group1'],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'orc-48ft',
    name: 'ORC 48ft',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 60, month: 343.2, year: 1359.2 },
  },
  {
    id: 'oyster-62',
    name: 'Oyster 62',
    tier: 'Grand Prix',
    category: 'maxi',
    tags: [],
    prices: { day: 119.2, month: 959.2, year: 3839.2 },
  },
  {
    id: 'pacer-42',
    name: 'Pacer 42',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'phantom',
    name: 'Phantom',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'pogo-30',
    name: 'Pogo 30',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'pogo-36',
    name: 'Pogo 36',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'pogo-40',
    name: 'Pogo 40',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'pogo-44',
    name: 'Pogo 44',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'pogo-50',
    name: 'Pogo 50',
    tier: 'Grand Prix',
    category: 'maxi',
    tags: [],
    prices: { day: 60, month: 343.2, year: 1359.2 },
  },
  {
    id: 'prima-38',
    name: 'Prima 38',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Group1'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'psaros-33',
    name: 'Psaros 33',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'quant-23',
    name: 'Quant 23',
    tier: 'Performance',
    category: 'foiling',
    tags: ['Foiling'],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'quarter-ton',
    name: 'Quarter Ton',
    tier: 'One Design',
    category: 'one-design',
    tags: ['Group1'],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'rc44',
    name: 'RC44',
    tier: 'Grand Prix',
    category: 'keelboat',
    tags: ['Group3'],
    prices: { day: 72, month: 412.8, year: 1639.2 },
  },
  {
    id: 'rebel-16',
    name: 'Rebel 16',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'reichel-pugh-51',
    name: 'Reichel Pugh 51',
    tier: 'Grand Prix',
    category: 'maxi',
    tags: [],
    prices: { day: 119.2, month: 959.2, year: 3839.2 },
  },
  {
    id: 'reichel-pugh-rp37',
    name: 'Reichel Pugh RP37',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'reverso-air',
    name: 'Reverso Air',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'rhodes-18',
    name: 'Rhodes 18',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'rs-aero',
    name: 'RS Aero',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'rs-elite',
    name: 'RS Elite',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'rs-feva-xl',
    name: 'RS Feva XL',
    tier: 'One Design',
    category: 'dinghy',
    tags: ['Group1'],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'rsx',
    name: 'RS:X',
    tier: 'One Design',
    category: 'dinghy',
    tags: ['Board', 'Olympic'],
    prices: { day: 10.39, month: 72, year: 719.2 },
  },
  {
    id: 'rs100',
    name: 'RS100',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'rs200',
    name: 'RS200',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'rs21',
    name: 'RS21',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'rs400',
    name: 'RS400',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'rs500',
    name: 'RS500',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'rs600',
    name: 'RS600',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'rs800',
    name: 'RS800',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'ruffian-23',
    name: 'Ruffian 23',
    tier: 'One Design',
    category: 'one-design',
    tags: ['Group1'],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 's2-79',
    name: 'S2 7.9',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 's2-91',
    name: 'S2 9.1',
    tier: 'One Design',
    category: 'one-design',
    tags: ['Group1'],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'salona-38',
    name: 'Salona 38',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Group1'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'santa-cruz-27',
    name: 'Santa Cruz 27',
    tier: 'One Design',
    category: 'one-design',
    tags: ['Group1'],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'santa-cruz-52',
    name: 'Santa Cruz 52',
    tier: 'Grand Prix',
    category: 'maxi',
    tags: ['Group1'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'sb20',
    name: 'SB20',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'schakel',
    name: 'Schakel',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'schock-35',
    name: 'Schock 35',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'seacart-30',
    name: 'Seacart 30',
    tier: 'One Design',
    category: 'one-design',
    tags: ['Group1', 'Multihull'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'seawind-1370',
    name: 'Seawind 1370',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Multihull'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'shark-24',
    name: 'Shark 24',
    tier: 'One Design',
    category: 'one-design',
    tags: ['Group1'],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'shields',
    name: 'Shields',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'sigma-600-active',
    name: 'Sigma 600 Active',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'sinergia-40',
    name: 'Sinergia 40',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'skeeta',
    name: 'Skeeta',
    tier: 'Performance',
    category: 'foiling',
    tags: ['Foiling'],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'sktsje',
    name: 'Skutsje',
    tier: 'Grand Prix',
    category: 'maxi',
    tags: ['Group1'],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'snipe',
    name: 'Snipe',
    tier: 'One Design',
    category: 'dinghy',
    tags: ['Group1'],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'soling',
    name: 'Soling',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'solo',
    name: 'Solo',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'soto-39',
    name: 'Soto 39',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'soto-48',
    name: 'Soto 48',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 60, month: 343.2, year: 1359.2 },
  },
  {
    id: 'sparkman--stephens-41-ft',
    name: 'Sparkman & Stephens 41 ft',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Group1'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'sparkman--stephens-54-ft',
    name: 'Sparkman & Stephens 54 ft',
    tier: 'Grand Prix',
    category: 'maxi',
    tags: [],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'squib',
    name: 'Squib',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'ssl47',
    name: 'SSL47',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 60, month: 343.2, year: 1359.2 },
  },
  {
    id: 'star',
    name: 'Star',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'sun-fast-30-od',
    name: 'Sun Fast 30 OD',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'sun-fast-3200',
    name: 'Sun Fast 3200',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Group1'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'sun-fast-3300',
    name: 'Sun Fast 3300',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Group1'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'sun-fast-3600',
    name: 'Sun Fast 3600',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Group1'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'sun-odyssey-33i',
    name: 'Sun Odyssey 33i',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Group1'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'sunbeam-22',
    name: 'Sunbeam 22',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'sup',
    name: 'SUP',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'super-maxi',
    name: 'Super Maxi',
    tier: 'Grand Prix',
    category: 'maxi',
    tags: [],
    prices: { day: 119.2, month: 959.2, year: 3839.2 },
  },
  {
    id: 'surprise',
    name: 'Surprise',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'swan-36',
    name: 'Swan 36',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'swan-45',
    name: 'Swan 45',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Group1'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'switch',
    name: 'Switch',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'sydney-40',
    name: 'Sydney 40',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'syra',
    name: 'SYRA',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'tartan-ten',
    name: 'Tartan Ten',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Group1'],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'tasar',
    name: 'Tasar',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'tempest',
    name: 'Tempest',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'tf10',
    name: 'TF10',
    tier: 'Performance',
    category: 'foiling',
    tags: ['Foiling', 'Multihull'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'tf35',
    name: 'TF35',
    tier: 'Performance',
    category: 'foiling',
    tags: ['Foiling', 'Multihull'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'thistle',
    name: 'Thistle',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'tofinou-7',
    name: 'Tofinou 7',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'topper',
    name: 'Topper',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'tp52',
    name: 'TP52',
    tier: 'Grand Prix',
    category: 'maxi',
    tags: ['Group3'],
    prices: { day: 119.2, month: 959.2, year: 3839.2 },
  },
  {
    id: 'ultimate-20',
    name: 'Ultimate 20',
    tier: 'One Design',
    category: 'one-design',
    tags: ['Group1'],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'vaan-r4',
    name: 'Vaan R4',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Multihull'],
    prices: { day: 60, month: 343.2, year: 1359.2 },
  },
  {
    id: 'valk',
    name: 'Valk',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'van-41',
    name: 'VAN 41',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'vanguard-15',
    name: 'Vanguard 15',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'vanguard-nomad',
    name: 'Vanguard Nomad',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'vector-65',
    name: 'Vector 6.5',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'viper-640',
    name: 'Viper 640',
    tier: 'One Design',
    category: 'one-design',
    tags: ['Group1'],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'volvo-ocean-65',
    name: 'Volvo Ocean 65',
    tier: 'Grand Prix',
    category: 'maxi',
    tags: [],
    prices: { day: 119.2, month: 959.2, year: 3839.2 },
  },
  {
    id: 'volvo-open-70',
    name: 'Volvo Open 70',
    tier: 'Grand Prix',
    category: 'maxi',
    tags: [],
    prices: { day: 119.2, month: 959.2, year: 3839.2 },
  },
  {
    id: 'vx-one',
    name: 'VX One',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'waarschip-1076',
    name: 'Waarschip 1076',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'wally-cento',
    name: 'Wally Cento',
    tier: 'Grand Prix',
    category: 'maxi',
    tags: [],
    prices: { day: 119.2, month: 959.2, year: 3839.2 },
  },
  {
    id: 'wally-rocket',
    name: 'Wally Rocket',
    tier: 'Grand Prix',
    category: 'maxi',
    tags: [],
    prices: { day: 60, month: 343.2, year: 1359.2 },
  },
  {
    id: 'waszp',
    name: 'WASZP',
    tier: 'Performance',
    category: 'foiling',
    tags: ['Foiling'],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'welbourn-50',
    name: 'Welbourn 50',
    tier: 'Grand Prix',
    category: 'maxi',
    tags: [],
    prices: { day: 60, month: 343.2, year: 1359.2 },
  },
  {
    id: 'weta-44',
    name: 'WETA 4.4',
    tier: 'One Design',
    category: 'dinghy',
    tags: ['Multihull'],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'windrush-edge',
    name: 'Windrush Edge',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'windsurfer-lt',
    name: 'Windsurfer LT',
    tier: 'One Design',
    category: 'dinghy',
    tags: ['Board'],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'wingfoil',
    name: 'WingFoil',
    tier: 'One Design',
    category: 'dinghy',
    tags: [],
    prices: { day: 2.39, month: 15.99, year: 64 },
  },
  {
    id: 'x-382',
    name: 'X-382',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'x-79',
    name: 'X-79',
    tier: 'One Design',
    category: 'one-design',
    tags: [],
    prices: { day: 5.59, month: 31.99, year: 159.2 },
  },
  {
    id: 'x-99',
    name: 'X-99',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'x4',
    name: 'X4-6',
    tier: 'Performance',
    category: 'keelboat',
    tags: [],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'xp-33',
    name: 'Xp 33',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Group1'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'xp-44',
    name: 'Xp 44',
    tier: 'Performance',
    category: 'keelboat',
    tags: ['Group1'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  },
  {
    id: 'young-88',
    name: 'Young 88',
    tier: 'One Design',
    category: 'one-design',
    tags: ['Group1'],
    prices: { day: 26.39, month: 148, year: 879.2 },
  }
];
